export default __webpack_public_path__ + "1412acca468669ca01a0d6307bb54da7.svg";